import { defaultOptionFromJSON, DefaultOptionRecord, IDefaultOptionData } from "common/records/DefaultOption";
import { Record, Map } from "immutable";

export const defaultsFromJSON = (json: Partial<IDefaultsData>): DefaultsRecord => {
  const record: IDefaultsRecord = { ...(json as any) };

  if (json.options) {
    record.options = Map(json.options).map((opt) => defaultOptionFromJSON(opt));
  }

  return new DefaultsRecord(record);
};

export interface IDefaultsData {
  options: { string: IDefaultOptionData };
}

export interface IDefaultsRecord {
  options: Map<string, DefaultOptionRecord>;
}

const defaultDefaultsRecordProps: IDefaultsRecord = {
  options: Map<string, DefaultOptionRecord>(),
};

export class DefaultsRecord extends Record(defaultDefaultsRecordProps) implements IDefaultsRecord {}
